import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

export const api = axios.create({ baseURL: API, withCredentials: true });

// Attach CSRF token (double-submit) on state-changing requests
api.interceptors.request.use((cfg) => {
  const m = (cfg.method || "get").toUpperCase();
  if (["POST", "PUT", "PATCH", "DELETE"].includes(m)) {
    const csrf = getCookie("pf_csrf");
    if (csrf) cfg.headers["X-CSRF-Token"] = csrf;
  }
  return cfg;
});

// On 401, try one silent refresh then retry the original request.
// A single in-flight refresh promise is shared so concurrent 401s never rotate the
// refresh token twice (which would trip reuse-detection and force a logout).
let refreshPromise = null;
function doRefresh() {
  if (!refreshPromise) {
    refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}
const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/register-partner", "/auth/refresh", "/auth/logout", "/auth/me"];
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const { config, response } = error;
    const url = config?.url || "";
    if (response && response.status === 401 && config && !config._retry && !NO_REFRESH.some((p) => url.includes(p))) {
      config._retry = true;
      try {
        await doRefresh();
        return api(config);
      } catch (e) {
        console.debug("token refresh failed, propagating original 401", e);
      }
    }
    return Promise.reject(error);
  }
);

export function tenantHeaders(slug, storeSlug) {
  const cfg = { headers: { "X-Tenant-Slug": slug } };
  if (storeSlug) cfg.params = { store: storeSlug };
  return cfg;
}

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Errore imprevisto";
}
